import React from 'react'
import cn from 'classnames'

import { CheckIcon } from '@components/icons/CheckIcon'
import { CheckboxInputProps } from './interface'

export function CheckboxInput({
  children,
  disabled,
  className,
  classNameCheckbox,
  checked,
  ...props
}: CheckboxInputProps) {
  return (
    <label className={cn('flex items-center w-full cursor-pointer', className)}>
      <div className='relative h-[24px]'>
        <input
          className={cn(
            'appearance-none min-w-[24px] w-[24px] min-h-[24px] h-[24px] bg-white dark:bg-dark-10 border border-gray dark:border-dark-10 rounded-[8px] checked:bg-primary dark:checked:bg-purple checked:border-primary dark:checked:border-primary focus:outline-none',
            classNameCheckbox,
            {
              'bg-gray-8 dark:bg-dark-10 border-gray-9 dark:border-dark-10':
                disabled,
            }
          )}
          type='checkbox'
          checked={checked}
          disabled={disabled}
          {...props}
        />
        {!disabled && (
          <CheckIcon
            className='text-white dark:text-white-2 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2'
            width='18'
            height='18'
          />
        )}
      </div>
      <div className='ml-[10px]'>{children}</div>
    </label>
  )
}
